<ui-card headline="Personal Information" [uiDisable]="disabled">
  <div fxFlex fxLayoutGap="18px">
    <div fxLayout="column" fxFlex="33">
      <mat-form-field>
        <mat-label>Last Name</mat-label>
        <input matInput [(ngModel)]="item.lastName" name="lastName" disabled>
      </mat-form-field>
      <mat-form-field>
        <mat-label>First Name</mat-label>
        <input matInput [(ngModel)]="item.firstName" name="firstName" disabled>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Middle Initial</mat-label>
        <input matInput [(ngModel)]="item.middleInit" name="middleInit" disabled>
      </mat-form-field>
    </div>

    <div fxLayout="column" fxFlex="33">
      <mat-form-field>
        <mat-label>Nickname</mat-label>
        <input matInput [(ngModel)]="item.nickname" name="nickname" disabled>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Prefix</mat-label>
        <input matInput [(ngModel)]="item.namePrefix" name="namePrefix" disabled>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Suffix</mat-label>
        <input matInput [(ngModel)]="item.nameSuffix" name="nameSuffix" disabled>
      </mat-form-field>

    </div>

    <div fxLayout="column" fxFlex="33">
      <mat-form-field>
        <mat-label>Login ID</mat-label>
        <input matInput [(ngModel)]="item.loginName" name="loginName" disabled>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Contact ID</mat-label>
        <input matInput [(ngModel)]="item.contactId" name="contactId" disabled>
      </mat-form-field>
    </div>
  </div>
</ui-card>


<contact-information></contact-information>


<email-notification></email-notification>

